export const properties = {
    oktaRedirectUri: '/osar/msi',
    oktaRedirectUriImplict: '/osar/msi/implicit/callback',
    oktaRedirectUriConfirmation: '/erums/order/confirmation/implicit/callback',
    erumsRedirectCookieName: 'erums-from-uri',
    clientBannerHeader: 'banner',
    headerStoreId: '',
    headerFulfillment: 'instore',
    storeId: '',
    tooltips: {},
    bannerConfiguration: {
        tomthumb: {
            banner: 'Tom Thumb',
            merchantSearchName: 'tomthumb',
            logoUrls: {
                color: 'TomThumb_RGB.svg',
                white: 'TomThumb_W.svg'
            }
        },
        albertsons: {
            banner: 'Albertsons',
            merchantSearchName: 'albertsons',
            logoUrls: {
                color: 'Albertsons_RGB.svg',
                white: 'Albertsons_W.svg'
            }
        },
        vons: {
            banner: 'Vons',
            merchantSearchName: 'vons',
            logoUrls: {
                color: 'Vons_RGB.svg',
                white: 'Vons_W.svg'
            }
        },
        safeway: {
            banner: 'Safeway',
            merchantSearchName: 'safeway',
            logoUrls: {
                color: 'Safeway_RGB.svg',
                white: 'Safeway_W.svg'
            }
        },
        randalls: {
            banner: 'Randalls',
            merchantSearchName: 'randalls',
            logoUrls: {
                color: 'Randalls_RGB.svg',
                white: 'Randalls_W.svg'
            }
        },
        pavilions: {
            banner: 'Pavilions',
                merchantSearchName: 'pavilions',
            logoUrls: {
                color: 'Pavilions_RGB.svg',
                white: 'Pavilions_W.svg'
            }
        },
        jewelosco: {
            banner: 'Jewel-Osco',
            merchantSearchName: 'jewelosco',
            logoUrls: {
                color: 'JewelOsco_Vert_Oval_RGB.svg',
                white: 'JewelOsco_Vert_Oval_W.svg'
            }
        },
        carrsqc: {
            banner: 'Carrs',
            merchantSearchName: 'carrsqc',
            logoUrls: {
                color: 'Carrs_RGB.svg',
                white: 'Carrs_W.svg'
            }
        },
        acmemarkets: {
            banner: 'ACME',
            merchantSearchName: 'acmemarkets',
            logoUrls: {
                color: 'Acme_RGB.svg',
                white: 'Acme_W.svg'
            }
        },
        shaws: {
            banner: 'Shaws\'s',
            merchantSearchName: 'shaws',
            logoUrls: {
                color: 'Shaws_RGB.svg',
                white: 'Shaws_W.svg'
            }
        },
        starmarket: {
            banner: 'Star Market',
            merchantSearchName: 'starmarket',
            logoUrls: {
                color: 'StarMarket_RGB.svg',
                white: 'StarMarket_W.svg'
            }
        },
        kingsfoodmarkets: {
            banner: 'Kings',
            merchantSearchName: 'kingsfoodmarkets',
            logoUrls: {
                color: 'Kingsfoodmarkets_RGB.svg',
                white: 'Kingsfoodmarkets_W.svg'
            }
        },
        haggen: {
            banner: 'Haggen',
            merchantSearchName: 'haggen',
            logoUrls: {
                color: 'haggen_RGB.svg',
                white: 'haggen_W.svg'
            }
        },
        andronicos: {
            banner: 'Andronico\'s',
            merchantSearchName: 'safeway',
            logoUrls: {
                color: 'andronicos_RGB.svg',
                white: 'andronicos_W.svg'
            }
        },
        balduccis: {
            banner: 'Balducci\'s',
            merchantSearchName: 'balduccis',
            logoUrls: {
                color: 'balduccis_RGB.svg',
                white: 'balduccis_W.svg'
            }
        },
        shopamigos: {
            banner: 'Amigos',
            merchantSearchName: 'amigosunited',
            logoUrls: {
                color: 'amigos_RGB.svg',
                white: 'amigos_W.svg'
            }
        },
        shopmarketstreet:{
            banner: 'Market Street',
            merchantSearchName: 'marketstreetunited',
            logoUrls: {
                color: 'marketStreet_RGB.svg',
                white: 'marketStreet_W.svg'
            }
        },
        shopunitedsupermarkets:{
            banner: 'United Supermarkets',
            merchantSearchName: 'unitedsupermarkets',
            logoUrls: {
                color: 'unitedSupermarkets_RGB.svg',
                white: 'unitedSupermarkets_W.svg'
            }
        },
        shopalbertsonsmarket:{
            banner: 'Albertson\'s Market',
            merchantSearchName: 'albertsonsmarket',
            logoUrls: {
                color: 'albertsonsMarket_RGB.svg',
                white: 'albertsonsMarket_W.svg'
            }
        },
    },
    PromoTypeDescription: {
        BOGO: 'Buy 1 Get 1 Free',
        B2G1: 'Buy Two Get 1 Free'
    },
    timer: {
        lastLoginAllowedTime: 45
    },
    summaryTexts: {
        sumamrySnapText: 'SNAP Eligible Item Total',
        sumamryNonSnapText: 'Non-SNAP Eligible Item Total'
    },
    rewardsConfig: {
        bannerMapper: {
            safeway: 'SAFEWAY',
            vons: 'VONS',
            randalls: 'RANDALLS',
            tomthumb: 'TOMTHUMB',
            acmemarkets: 'ACMEMARKETS',
            carrsqc: 'CARRSQC',
            jewelosco: 'JEWELOSCO',
            albertsons: 'ALBERTSONS',
            starmarket: 'STARMARKET',
            shaws: 'SHAWS',
            pavilions: 'PAVILIONS',
            kingsfoodmarkets: 'KINGSFOODMARKETS',
            haggen: 'HAGGEN',
            andronicos: 'ANDRONICOS',
            balduccis: 'BALDUCCIS',
            shopamigos: 'SHOPAMIGOS',
            shopmarketstreet: 'SHOPMARKETSTREET',
            shopunitedsupermarkets: 'SHOPUNITEDSUPERMARKETS',
            shopalbertsonsmarket: 'SHOPALBERTSONSMARKET',
        },
        displaybleBannerNames : {
            safeway: 'Safeway',
            vons: 'Vons',
            albertsons: 'Albertsons',
            shaws: 'Shaws',
            andronicos: 'Andronicos',
            jewelosco: 'Jewel-Osco',
            acmemarkets: 'Acme',
            starmarket: 'Star Market',
            carrsqc: 'Carrs',
            randalls: 'Randalls',
            tomthumb: 'Tom Thumb',
            pavilions: 'Pavilions',
            haggen: 'Haggen',
            kingsfoodmarkets: 'Kings',
            balduccis: 'Balduccis',
            shopamigos: 'Amigos',
            shopmarketstreet: 'Market Street',
            shopunitedsupermarkets: 'United Supermarkets',
            shopalbertsonsmarket: 'Albertsons Market',
        },
        errorText: 'Sorry, we\'re having technical difficulties, please check back later.',
        noSubscriptionDefaultText: 'Shop Now',
        FULFILLMENT: 'FULFILLMENT',
        METHOD: 'METHOD',
        DELIVERY: 'DELIVERY',
        PICKUP: 'PICKUP',
        DUG: 'DUG',
        SHOP: 'SHOP',
        SLOT: 'SLOT',
        storeSearchSize: '10',
        radius: '50',
        expiredPaymentMethod: 'This card is expired',
        serviceErrorMessage: 'Apologies, our site is currently experiencing technical difficulties, please try again later.',
        addressErrorMessage: 'Sorry, This address is not available for Schedule & Save orders.',
        enableBirthdayModule: true,
        enableFuelStationModule: true,
        v2Enabled: true,
        disableEconReceiptURL: false,
        disableMulticlipRewardGallery: false,
        disableToastmessageRewardPage: false,
        imagePath: '//images.albertsons-media.com/is/image/ABS/',
        childList: "childList",
        cookiesOneTrustConsentEle: "onetrust-consent-sdk",
        partnerHub:{
            safeway: true,
            vons: true,
            randalls: true,
            tomthumb: true,
            acmemarkets: true,
            carrsqc: true,
            jewelosco: true,
            albertsons: true,
            starmarket: true,
            shaws: true,
            pavilions: true,
            kingsfoodmarkets: true,
            haggen: true,
            andronicos: true,
            balduccis: true,
            shopamigos: true,
            shopmarketstreet: true,
            shopunitedsupermarkets: true,
            shopalbertsonsmarket: true,
        },
        partnerLanding:{
            safeway: true,
            vons: true,
            randalls: true,
            tomthumb: true,
            acmemarkets: true,
            carrsqc: true,
            jewelosco: true,
            albertsons: true,
            starmarket: true,
            shaws: true,
            pavilions: true,
            kingsfoodmarkets: true,
            haggen: true,
            andronicos: true,
            balduccis: true,
            shopamigos: true,
            shopmarketstreet: true,
            shopunitedsupermarkets: true,
            shopalbertsonsmarket: true,
        },
        fuelSiteBanner: {
            safeway: true,
            vons: true,
            randalls: true,
            tomthumb: true,
            acmemarkets: true,
            carrsqc: true,
            jewelosco: false,
            albertsons: true,
            starmarket: false,
            shaws: false,
            pavilions: true,
            kingsfoodmarkets: false,
            haggen: true,
            andronicos: true,
            balduccis: false,
            shopamigos: true,
            shopmarketstreet: true,
            shopunitedsupermarkets: true,
            shopalbertsonsmarket: true,
        },
        cashRewardsBanner:{
            safeway: true,
            vons: true,
            randalls: true,
            tomthumb: true,
            acmemarkets: true,
            carrsqc: true,
            jewelosco: true,
            albertsons: true,
            starmarket: true,
            shaws: true,
            pavilions: true,
            kingsfoodmarkets: true,
            haggen: true,
            andronicos: true,
            balduccis: true,
            shopamigos: true,
            shopmarketstreet: true,
            shopunitedsupermarkets: true,
            shopalbertsonsmarket: true,
        },
        freshpassRebranding: false,
        freshpassText: 'FreshPass',
        foruBanner: 'banner for U+',
        nonFreshpassBanners: ['haggen','andronicos','shopamigos','shopmarketstreet', 'shopunitedsupermarkets','shopalbertsonsmarket'],
        expediaTerms: 'https://www.forutravel.com/legal/terms',
        expediaPrivacy: 'https://www.forutravel.com/legal/privacy',
        experimentData: 'https://legal.expediagroup.com/privacy/privacy-and-cookies-statements/partner-sites1/expedia-partner-solutions1?field_b2ccountry_target_id=139&field_b2clanguage_target_id=33',
        mdpcid: {
            safeway: 'MDPCID=forUTravel-US.DPS.Albertsons.SafewayLP-BookNowCTA.HOTEL',
            vons: 'MDPCID=forUTravel-US.DPS.Albertsons.VonsLP-BookNowCTA.HOTEL',
            randalls: 'MDPCID=forUTravel-US.DPS.Albertsons.RandallsLP-BookNowCTA.HOTEL',
            tomthumb: 'MDPCID=forUTravel-US.DPS.Albertsons.TomThumbLP-BookNowCTA.HOTEL',
            acmemarkets: 'MDPCID=forUTravel-US.DPS.Albertsons.AcmeLP-BookNowCTA.HOTEL',
            carrsqc: 'MDPCID=forUTravel-US.DPS.Albertsons.CarrsLP-BookNowCTA.HOTEL',
            jewelosco: 'MDPCID=forUTravel-US.DPS.Albertsons.JewelOscoLP-BookNowCTA.HOTEL',
            albertsons: 'MDPCID=forUTravel-US.DPS.Albertsons.AlbertsonsLP-BookNowCTA.HOTEL',
            starmarket: 'MDPCID=forUTravel-US.DPS.Albertsons.StarMarketLP-BookNowCTA.HOTEL',
            shaws: 'MDPCID=forUTravel-US.DPS.Albertsons.ShawsLP-BookNowCTA.HOTEL',
            pavilions: 'MDPCID=forUTravel-US.DPS.Albertsons.PavilionsLP-BookNowCTA.HOTEL',
            kingsfoodmarkets: 'MDPCID=forUTravel-US.DPS.Albertsons.KingsLP-BookNowCTA.HOTEL',
            haggen: 'MDPCID=forUTravel-US.DPS.Albertsons.HaggenNWLP-BookNowCTA.HOTEL',
            andronicos: 'MDPCID=forUTravel-US.DPS.Albertsons.Andronicos-BookNowCTA.HOTEL',
            balduccis: 'MDPCID=forUTravel-US.DPS.Albertsons.Balduccis-BookNowCTA.HOTEL',
            shopamigos: '',
            shopmarketstreet:'',
            shopunitedsupermarkets:'',
            shopalbertsonsmarket:'',
        },
        manageMdpcid: {
            safeway: 'MDPCID=forUTravel-US.DPS.Albertsons.SafewayLP-ManageBookingsCTA.HOTEL',
            vons: 'MDPCID=forUTravel-US.DPS.Albertsons.VonsLP-ManageBookingsCTA.HOTEL',
            randalls: 'MDPCID=forUTravel-US.DPS.Albertsons.RandallsLP-ManageBookingsCTA.HOTEL',
            tomthumb: 'MDPCID=forUTravel-US.DPS.Albertsons.TomThumbLP-ManageBookingsCTA.HOTEL',
            acmemarkets: 'MDPCID=forUTravel-US.DPS.Albertsons.AcmeLP-ManageBookingsCTA.HOTEL',
            carrsqc: 'MDPCID=forUTravel-US.DPS.Albertsons.CarrsLP-ManageBookingsCTA.HOTEL',
            jewelosco: 'MDPCID=forUTravel-US.DPS.Albertsons.JewelOscoLP-ManageBookingsCTA.HOTEL',
            albertsons: 'MDPCID=forUTravel-US.DPS.Albertsons.AlbertsonsLP-ManageBookingsCTA.HOTEL',
            starmarket: 'MDPCID=forUTravel-US.DPS.Albertsons.StarMarketLP-ManageBookingsCTA.HOTEL',
            shaws: 'MDPCID=forUTravel-US.DPS.Albertsons.ShawsLP-ManageBookingsCTA.HOTEL',
            pavilions: 'MDPCID=forUTravel-US.DPS.Albertsons.PavilionsLP-ManageBookingsCTA.HOTEL',
            kingsfoodmarkets: 'MDPCID=forUTravel-US.DPS.Albertsons.KingsLP-ManageBookingsCTA.HOTEL',
            haggen: 'MDPCID=forUTravel-US.DPS.Albertsons.HaggenNWLP-ManageBookingsCTA.HOTEL',
            andronicos: 'MDPCID=forUTravel-US.DPS.Albertsons.Andronicos-ManageBookingsCTA.HOTEL',
            balduccis: 'MDPCID=forUTravel-US.DPS.Albertsons.Balduccis-ManageBookingsCTA.HOTEL',
            shopamigos: '',
            shopmarketstreet:'',
            shopunitedsupermarkets:'',
            shopalbertsonsmarket:'',
        },
    }
};
